// 声明首页七个按钮的枚举被用于曝光和点击上报
export const homeButtonEnum = {
  bannerButton: '首屏banner按钮',
  FirstScreenButton0: '首屏内容介绍按钮',
  FirstScreenButton1: '首屏编辑器介绍按钮',
  FirstScreenButton2: '首屏数据介绍按钮',
}

export const homeButtonList = [
  'bannerButton',
  'FirstScreenButton0',
  'FirstScreenButton1',
  'FirstScreenButton2',
]
